// extracted by mini-css-extract-plugin
module.exports = {"is-mob":"serverBreadcrumbs_is-mob__8RS6y","is-desk":"serverBreadcrumbs_is-desk__Z1YpS","breadcrumbs":"serverBreadcrumbs_breadcrumbs__mtZWB"};